// Placeholder content for Imagine Designs.
// Swap these values for real business details and copy when they're available.

import imagineDesignsBuilding from "../assets/imagine-designs-building.jpg";
import mainCurtainImage from "../assets/main-curtain-image.webp";
import linenCurtain from "../assets/linen-curtain.webp";
import blindAndLampShade from "../assets/blind-and-lamp-shade.jpg";
import linenCurtainBreeze from "../assets/linen-curtain-breeze.webp";

export const business = {
  name: "Imagine Designs",
  phone: "027 440 0071",
  email: "traceyimaginedesign@gmail.com",
  address: "96b Commercial Street, Takaka",
  hours: "Mon – Fri: 9am – 4pm, or by appointment",
};

export const images = {
  hero: mainCurtainImage, // real photo
  about: imagineDesignsBuilding, // real photo of the shop
  servicesCurtains: linenCurtain, // real photo
  servicesBlinds: blindAndLampShade, // real photo
  servicesFabrics: linenCurtainBreeze, // real photo
};

export const services = [
  {
    title: "Curtains",
    description:
      "Custom made floor to ceiling curtains, either lined on a single track or sheers and liners on a double track.",
    image: images.servicesCurtains,
  },
  {
    title: "Blinds",
    description:
      "Sunscreen roller blinds, blockout roller blinds, translucent roller blinds, venetians, woodmates, duettes, roman blinds, and shutters.",
    image: images.servicesBlinds,
  },
  {
    title: "Fabrics",
    description:
      "Linens, velvets, cotton prints, sheers, and liners, from New Zealand's leading textiles houses.",
    image: images.servicesFabrics,
  },
];
